import React from 'react';

// Config
import { config } from '../../config';

const Consent = class Consent extends React.Component {
  constructor() {
    super();

    // Set the initial state
    this.state = {
      agreementsFetched: false,
      agreementsChecked: false
    };

    // Empty agreements handler
    this.noAgreements = false;
  }

  componentDidMount() {
    // Enable the continue button when agreements are checked
    document.addEventListener('agreementsChecked', this.checked);

    // Disable the continue button when agreements are unchecked
    document.addEventListener('agreementsUnchecked', this.unchecked);

    // Move on when the agreements have been completed
    document.addEventListener('agreementsComplete', this.complete);

    // Stop onboarding if there are no agreements to sign
    document.addEventListener('agreementsFetched', this.fetched);
  }

  checked = () => {
    if (this.state.multipleAgreements) {
      return;
    }

    this.setState({
      agreementsChecked: true
    });

    this.button.disabled = false;

    this.enableNext();
  }

  unchecked = () => {
    if (this.state.multipleAgreements) {
      return;
    }

    const { parent } = this.props;

    this.setState({
      agreementsChecked: false
    });

    parent.setState({
      next: null
    });

    this.button.disabled = true;
  }

  complete = () => {
    const { nextStep } = this.props;

    if(!this.noAgreements) {
      this.setState({
        agreementsFetched: false
      });

      window.Agreements.agrFetched = false;

      document.removeEventListener('agreementsComplete', this.complete);

      nextStep();
    }
  }

  fetched = () => {
    const { parent } = this.props;

    if(window.Agreements.agrArr && window.Agreements.agrArr.length === 0) {
      this.noAgreements = true;
      
      parent.setState({
        unsupported: true,
        unsupportedDetails: this.props.translation.unsupported_msg.consent
      });
    } else if (window.Agreements.agrArr && window.Agreements.agrArr.length > 1) {
      this.setState({
        multipleAgreements: true
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('agreementsChecked', this.checked);
    document.removeEventListener('agreementsUnchecked', this.unchecked);
    document.removeEventListener('agreementsComplete', this.complete);
    document.removeEventListener('agreementsFetched', this.fetched);
  }

  componentDidUpdate() {
    const { agreements, button, statusClass } = this.props;
    const { SessionStore } = this.props.store;
    const { userData } = SessionStore;

    if(button) {
      this.button = button;
    }

    let location = '';
    let hideButton = true;

    if(agreements && agreements.recordingConsent) {
      location = agreements.recordingConsent;
    }

    if (config.dmvInstallSids.indexOf(userData.installSid) > -1) {
      location = 'dmv-hybrid-check-in';
      hideButton = false;
    }

    if(button && statusClass === 'slide-active' && !this.state.agreementsChecked) {
      button.disabled = true;
    }

    // Get recording consent agreement
    if(
      window.Agreements &&
      !this.state.agreementsFetched &&
      statusClass === 'slide-active'
    ) {
      window.Agreements.agrFetched = false;

      const agrOpts = {
        mode: 'inline',
        containerId: 'agreement-container',
        location: location || 'extension-recording-consent',
        target: Date.now(),
        account: userData.deploymentSid || sessionStorage.getItem('installSid'),
        application: 'AP6800b9e2e1794dbbbf6ad866194821d3',
        hideButton
      };

      window.Agreements.setup(agrOpts);

      this.setState({
        agreementsFetched: true
      });
    }
  }

  enableNext() {
    const { onComplete, parent } = this.props;

    const next = () => {
      if(onComplete) {
        const mediaDevices = {
          audio: parent.state.microphone,
          video: parent.state.webcam
        }

        onComplete(mediaDevices);
      }

      window.Agreements.submit();
    }

    parent.setState({
      next: next
    });
  }

  render() {
    const { statusClass } = this.props;
    const translation = this.props.translation.consent;

    return (
      <main className={`panel panel--medium ${statusClass}`} aria-labelledby="step2">
        <h2 className="meta">
          {translation.heading}
        </h2>

        <div
          className="loader--async panel__agreement"
          id="agreement-container"
        />
      </main>
    )
  }
}

export default Consent;



// WEBPACK FOOTER //
// ./src/app/components/SessionStart/Consent.js